<template>
  <div :class="headerClass">
    <div class="button_menu--holder">
      <button type="button" name="button_menu" :class="buttonMenuClass" v-on:click="toggleMenu">
        <svg class="icon icon-open-button"><use xlink:href="#icon-open-button"></use></svg>
        <svg class="icon icon-close-button"><use xlink:href="#icon-close-button"></use></svg>
        <template v-if="showMenu">CLOSE</template>
        <template v-else>MENU</template>
      </button>
    </div>

    <div class="container">
      <div :class="navClass">
        <nav class="column nav">
          <ul :class="menuClass">
            <li class="column is-12">
              <a href="#top" title="Top" v-smooth-scroll="{ duration: 1000 }" @click="closeMenu()">
                Top
              </a>
            </li>
            <li class="column is-12">
              <a href="#introduction" title="Introduction" v-smooth-scroll="{ duration: 1000, offset: -50 }" @click="closeMenu()">
                Introduction
              </a>
            </li>
            <li class="column is-12">
              <a href="#story" title="Story" v-smooth-scroll="{ duration: 1000, offset: -50 }" @click="closeMenu()">
                Story
              </a>
            </li>
            <li class="column is-12">
              <a href="#cast" title="Cast" v-smooth-scroll="{ duration: 1000, offset: -50 }" @click="closeMenu()">
                Cast
              </a>
            </li>
            <li class="column is-12">
              <a href="#staff" title="Staff" v-smooth-scroll="{ duration: 1000, offset: -50 }" @click="closeMenu()">
                Staff
              </a>
            </li>
            <li class="column is-12">
              <a href="#director" title="Director's Statement" v-smooth-scroll="{ duration: 1000, offset: -50 }" @click="closeMenu()">
                Director's Statement
              </a>
            </li>
            <li class="column is-12">
              <a href="#writer" title="Writer's Comment" v-smooth-scroll="{ duration: 1000, offset: -50 }" @click="closeMenu()">
                Writer's Comment
              </a>
            </li>
            <li class="column is-12">
              <a href="#theme-song" title="Theme song" v-smooth-scroll="{ duration: 1000, offset: -50 }" @click="closeMenu()">
                Theme song
              </a>
            </li>
            <li class="column is-12">
              <a href="#comment" title="Comment" v-smooth-scroll="{ duration: 1000, offset: -50 }" @click="closeMenu()">
                Comment
              </a>
            </li>
            <li class="column is-12">
              <a href="#trailer" title="Trailer"  @click="showModal()">
                Trailer
              </a>
            </li>
            <li class="column is-12">
              <a href="#theater" title="Theater" v-smooth-scroll="{ duration: 1000, offset: -50 }" @click="closeMenu()">
                Theater
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div class="sns_block">
      <ul class="columns is-gapless is-mobile">
        <li class="column is-narrow">
          <a href="https://www.facebook.com/namaemovie/" class="sns_block--link" title="Facebook" target="_blank"><svg class="icon icon-facebook"><use xlink:href="#icon-facebook"></use></svg></a>
        </li>
        <li class="column is-narrow">
          <a href="https://twitter.com/namae_ibaraki" class="sns_block--link" title="Twitter" target="_blank"><svg class="icon icon-twitter"><use xlink:href="#icon-twitter"></use></svg></a>
        </li>
        <li class="column is-narrow">
          <a href="https://www.instagram.com/the_name_2018/" class="sns_block--link" title="Instagram" target="_blank"><svg class="icon icon-instagram"><use xlink:href="#icon-instagram"></use></svg></a>
        </li>
      </ul>
    </div>

    <modal-trailer :isActive="isActiveModal" v-on:closeModal="closeModal"></modal-trailer>
  </div>
</template>

<script>
import Vue from 'vue'
import vueSmoothScroll from 'vue-smooth-scroll'
import ModalTrailer from '@/components/ModalTrailer'

Vue.use(vueSmoothScroll)
Vue.component('modal-trailer', ModalTrailer)

export default {
  name: 'navigation',
  data () {
    return {
      showMenu: false,
      isActiveModal: true
    }
  },

  computed: {
    headerClass () {
      if (this.showMenu) {
        return 'navigation is-active'
      } else {
        return 'navigation'
      }
    },
    navClass () {
      if (this.showMenu) {
        return 'columns nav--holder is-gapless is-active'
      } else {
        return 'columns nav--holder is-gapless'
      }
    },
    menuClass () {
      if (this.showMenu) {
        return 'columns is-gapless menu is-mobile is-multiline is-active'
      } else {
        return 'columns is-gapless menu is-mobile is-multiline'
      }
    },
    snsClass () {
      if (this.showMenu) {
        return 'sns_menu column is-narrow is-active'
      } else {
        return 'sns_menu column is-narrow'
      }
    },
    buttonMenuClass () {
      if (this.showMenu) {
        return 'button_menu is-active'
      } else {
        return 'button_menu'
      }
    }
  },

  methods: {
    toggleMenu () {
      if (this.showMenu) {
        this.showMenu = false
      } else {
        this.showMenu = true
      }
    },
    closeMenu () {
      this.showMenu = false
    },

    showModal () {
      this.isActiveModal = true
    },
    closeModal () {
      this.isActiveModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Navigation.vue